import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, NgModule, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { SafeUrlPipeModule } from '../../../pipes/safe-url.pipe';
import { isIFrameSameOrigin } from '../../../shared/helpers/is-same-origin';
import { OeAppPersonService } from '../../../shared/oe-app-person.service';
import { OeAppService } from '../../../shared/oe-app.service';
import { SharedModule } from '../../../shared/shared.module';
import { WindowService } from '../../../shared/window.service';
import { LevelSelectionEvent } from '../level-selection-event';
import { LevelSelectionType } from '../../../shared/types/level-selection-type';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserwaySyncModule } from '../../../shared/userway-sync.directive';

@Component({
  selector: 'lp2-level-selection-iframe',
  template: '<iframe #iframe lp2UserwaySync [src]="url | safeUrl"></iframe>',
  styles: [`
    :host {
      display: block;
      width: 100%;
      height: 100%;

      iframe {
        width: 100%;
        height: 100%;
        border: none;
      }
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LevelSelectionIframeComponent implements OnChanges {
  @ViewChild('iframe') iframe: ElementRef<HTMLIFrameElement>;
  @Input() levelSelectionType: LevelSelectionType = LevelSelectionType.ACTIVATION;

  public url: string;


  constructor(
    private readonly oeAppService: OeAppService,
    private readonly oeAppPersonService: OeAppPersonService,
    private readonly windowService: WindowService,
    private readonly modal: NgbActiveModal,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.updateUrl();
    window.addEventListener('message', this.handleEvents);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.levelSelectionType) {
      this.updateUrl();
    }
  }

  private updateUrl(): void {
    this.url = `${this.oeAppService.webLevelSelectionPageHost}?` +
      `env=${this.oeAppService.environment}&` +
      `lang=${this.oeAppPersonService.preferredLang}&` +
      `placementTestEnabled=${this.oeAppPersonService.placementTestEnabled}&` +
      `levelSelectionType=${this.levelSelectionType}`;
  }

  private handleEvents = ({ data, origin }) => {
    if (!isIFrameSameOrigin(this.oeAppService.webLevelSelectionPageHost, origin)) {
      return;
    }

    switch (data.type) {
      case LevelSelectionEvent.LEVEL_CONFIRMED:
        this.windowService.redirectToHref('/');
        break;
      case LevelSelectionEvent.TAKE_PLACEMENT_TEST:
        this.windowService.redirectToHref('/placement-quiz.html');
        break;
      case LevelSelectionEvent.CLOSE_LEVEL_SELECTION:
        this.modal.close();
        break;
    }
  }
}

@NgModule({
  imports: [SharedModule, SafeUrlPipeModule, UserwaySyncModule],
  exports: [LevelSelectionIframeComponent],
  declarations: [LevelSelectionIframeComponent],
  providers: [NgbActiveModal],
})
export class LevelSelectionIframeModule { }



// WEBPACK FOOTER //
// ./ts/app/home/level-selection/level-selection-iframe/level-selection-iframe.component.ts